const prefix = 'CUTOUT:';

export default class Cutout {
    /** Cutout Type */
    type: CutoutType;
    /** Distance to center from male seam.  */
    distanceFromMale: number;
    /** Distance to center from Connector 1 (C1).  */
    distanceFromC1: number;
    /** As measured along male to female.  */
    length: number;
    /** As measured from Connector 1 (C1) to C2.  */
    width: number;

    constructor(fields: string[]) {
        // make indices 1 based to agree with documentation
        fields.unshift('');
        this.type = parseInt(fields[1]?.substring(prefix.length));
        this.distanceFromMale = parseFloat(fields[2]);
        this.distanceFromC1 = parseFloat(fields[3]);
        this.length = parseFloat(fields[4]);
        this.width = parseFloat(fields[5]);
    }
}

export enum CutoutType {
    None = 0,
    Rectangle = 1,
    Round = 2,
}
